module.exports = __webpack_public_path__ + "static/media/bracketCutout.378e1cbb.svg";